import { ChartColors } from '@nimbus-library/features/charts/models/chart-colors';
import { IHandledRatioColors } from '@nimbus-library/features/charts/models/handled-ratio.colors';

type IThemePropertyModels = { [key in ChartThemeProperty]: ChartColors };

export type IChartThemeModel = IThemePropertyModels & { heatmapRationColors: IHandledRatioColors };

// noinspection JSUnusedGlobalSymbols
export enum ChartThemeProperty {
  Line = 'line',
  Font = 'font',
  Empty = 'empty',
  Handled = 'handled',
  NotHandled = 'notHandled',
  AllCalls = 'allCalls',
  Rona = 'rona',
  Declined = 'declined',
  HandledNotHandledOverlay = 'handledNotHandledOverlay',
  Summary = 'summary',
  QueueTime = 'queueTime',
  Available = 'available',
  NotAvailable = 'notAvailable',
  Enabled = 'enabled',
  Disabled = 'disabled',
  DatabarIndicator = 'databarIndicator',
  Connected = 'connected',
  InQueue = 'inQueue',
  InIvr = 'inIvr',
  InIvrAfterQueue = 'inIvrAfterQueue',
  TrendLine = 'trendLine',
  AllConversation = 'allConversation',
  HangupInIvr = 'hangupInIvr',
  HangupInQueue = 'hangupInQueue',
  HangupBeforeAccept = 'hangupBeforeAccept',
  HangupByWorkflow = 'hangupByWorkflow',
  HangupAfterQueue = 'hangupAfterQueue',
  HangupInIVRAfterQueue = 'hangupInIVRAfterQueue',
  HangupSLA = 'hangupSLA',
  Reachability = 'reachability',
  OutboundReachability = 'outboundReachability',
  AcceptanceSLA = 'acceptanceSLA',
  LegendOff = 'legendOff',
  SwitchboardEnabled = 'switchboardEnabled',
  SwitchboardDisabled = 'switchboardDisabled',
  CalendarOpen = 'calendarOpen',
  CalendarHoliday = 'calendarHoliday',
  CalendarClosed = 'calendarClosed',
  CalendarSpecial = 'calendarSpecial',
  CalendarSpecial2 = 'calendarSpecial2',
  CalendarSpecial3 = 'calendarSpecial3',
  CalendarSpecial4 = 'calendarSpecial4',
  ChartSkillBased = 'chartSkillBased',
  Active = 'active',
  Voicemail = 'voicemail',
  TransferredByWorkflow = 'TransferredByWorkflow',
  TransferredByUser = 'TransferredByUser',
  TransferFailed = 'TransferFailed',
  Transferring = 'Transferring',
  Parked = 'Parked',
  PutOnHold = 'PutOnHold',
  Other = 'other',
  Uncompleted = 'uncompleted',
  ServicesRunning = 'servicesRunning',
  PSTNRunning = 'pstnRunning',
  Suspended = 'suspended',
  ServicesApplied = 'servicesApplied',
  PSTNApplied = 'pstnApplied',
  DestinationAccepted = 'destinationAccepted',
  DestinationDeclined = 'destinationDeclined',
  DestinationNotReached = 'destinationNotReached',
  LostInQueue = 'lostInQueue',
  UserAborted = 'userAborted',
  DialingOut = 'dialingOut',
  LicenseActive = 'licenseActive',
  LicenseTrial = 'licenseTrial',
  LicenseSuspended = 'licenseSuspended',
  LicenseExpired = 'licenseExpired',
  LicenseCanceled = 'licenseCanceled',
  LicenseLab = 'licenseLab',
  CanceledByExternalSystem = 'canceledByExternalSystem',
  Inbound = 'inbound',
  Outbound = 'outbound',
  None = 'none',
  Audio = 'audio',
  InstantMessaging = 'instantMessaging',
  Email = 'email',
  ExternalTask = 'externalTask',
  Accepted = 'accepted',
  Canceled = 'canceled',
  Consulted = 'consulted',
  Transferred = 'transferred',
  OutboundUserNotAccepted = 'outboundUserNotAccepted',
  OutboundUserAborted = 'outboundUserAborted',
  MarkedAsHandledByUser = 'markedAsHandledByUser',
  MarkedAsHandledByWorkflow = 'markedAsHandledByWorkflow',
  UserSessionDestinationNotReached = 'userSessionDestinationNotReached',
  Ringing = 'ringing',
  StandbyDutyAccepted = 'standbyDutyAccepted',
}
